import { useAppearance } from '../theme/ThemeProvider';

/** [mode, toggleMode] — light/dark state lives in <ThemeProvider>. */
export default function useTheme() {
  const { mode, toggle } = useAppearance();
  return [mode, toggle];
}
